import React from "react";
import { Trans } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Loading, MoreItemsMessageS } from "../common";
import { DisplayFlexS } from "../../../utils/stylesHelpers";
import { PROFILE_REVIEW_PER_PAGE } from "../../constants/pagination";
import { ReviewEntity } from "../company/reviewsBlock";
import { CommentWrapS } from "./profileComponentS";

export const ProfileReviewsComponent = ({ reviews, reviewCount, onPagination, isReviewsLoading }) => (
  <DisplayFlexS
    direction="column"
    directionScreenMedium="column"
    width="100%"
    aItems="stretch"
    alignItemsScreenMedium="stretch"
  >

    <InfiniteScroll
      dataLength={reviews.length}
      next={onPagination}
      hasMore={isReviewsLoading || Math.ceil(reviewCount / PROFILE_REVIEW_PER_PAGE) !== Math.ceil(reviews.length / PROFILE_REVIEW_PER_PAGE)}
      loader={<Loading />}
      style={{ overflow: 'none', width: '100%' }}
      endMessage={
        <MoreItemsMessageS>
          <Trans i18nKey="general.paginator.noMoreItemsMessage" />
        </MoreItemsMessageS>
      }
    >
      {
        reviews.map((review) => (
          <CommentWrapS key={review._id}>
              <ReviewEntity
                  name={review.createdBy.name}
                  text={review.text}
              />
          </CommentWrapS>
        ))
      }
    </InfiniteScroll>

  </DisplayFlexS>
);
